.dock {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 40;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  max-width: calc(100vw - 32px);
}

.fab {
  position: relative;
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  background: var(--accent);
  color: var(--accent-foreground);
  border: 0;
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-out);
}

.fab:hover {
  background: var(--accent-hover);
}

.badge {
  position: absolute;
  top: -8px;
  right: -8px;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  display: grid;
  place-items: center;
  font-size: 0.75rem;
  font-weight: 700;
  background: var(--text-primary);
  color: var(--bg-primary);
}

.dot {
  position: absolute;
  left: 6px;
  bottom: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--text-muted);
  box-shadow: 0 0 0 2px var(--accent);
}

.dotOk {
  background: var(--status-ok);
}

.panel {
  width: 340px;
  max-width: 100%;
  max-height: calc(100dvh - 120px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.panelHead {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px 12px;
  align-items: start;
}

.panelHead h2 {
  font-size: 1.0625rem;
  margin-bottom: 4px;
}

.switch {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: var(--text-secondary);
  cursor: pointer;
}

.close {
  grid-row: 1;
  grid-column: 2;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-primary);
  cursor: pointer;
}

.calls {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card {
  padding: 12px;
  border: 1px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.held {
  opacity: 0.75;
  border-style: dashed;
}

.cardHead {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.who {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.who strong {
  overflow-wrap: anywhere;
}

.who span {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.timer {
  font-family: var(--font-mono);
  color: var(--text-secondary);
}

.controls {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(64px, 1fr));
  gap: 6px;
}

.ctl {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 4px;
  font-size: 0.75rem;
  background: transparent;
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
  cursor: pointer;
}

.ctl:hover:not(:disabled) {
  border-color: var(--text-secondary);
}

.ctl[aria-pressed='true'] {
  border-color: var(--accent);
  color: var(--accent-text);
}

.ctl:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.end {
  color: var(--status-busy);
}

.keysIcon {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  height: 18px;
  line-height: 18px;
}

.transfer {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.transfer input {
  flex: 1 1 100%;
}

.small {
  flex: 1 1 auto;
  min-height: 36px;
  padding: 0 10px;
  font-size: 0.8125rem;
  background: transparent;
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
  cursor: pointer;
}

.dial {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dial input,
.transfer input {
  min-height: 44px;
  padding: 0 12px;
  font: inherit;
  font-family: var(--font-mono);
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
  min-width: 0;
}

.dial input {
  flex: 1;
}

.erase {
  background: transparent;
  border: 0;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 8px;
}

.pad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.key {
  min-height: 44px;
  font-family: var(--font-mono);
  font-size: 1.125rem;
  background: transparent;
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  cursor: pointer;
}

.key:hover:not(:disabled) {
  border-color: var(--text-secondary);
  background: var(--bg-primary);
}

.key:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.round {
  flex: none;
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border: 0;
  cursor: pointer;
  border-radius: 50%;
  color: #fff;
}

.round:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.accept {
  background: var(--status-ok);
}

.hang {
  background: var(--status-busy);
}

.incoming {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 60;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 380px;
  max-width: calc(100vw - 32px);
  padding: 16px;
  background: var(--bg-elevated);
  border: 1px solid var(--accent);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.incoming .who {
  flex: 1;
}

@media (prefers-reduced-motion: no-preference) {
  .incoming {
    animation: ring 1.2s ease-in-out infinite;
  }
}

@keyframes ring {
  0%,
  100% {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 0 0 rgba(244, 119, 69, 0.5);
  }
  50% {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 0 8px rgba(244, 119, 69, 0);
  }
}
